(function () {
  'use strict';

  var STORAGE_KEY = 'store-color-mode';
  var EXPIRY_MS = 24 * 60 * 60 * 1000; // 24 hours
  var BUTTON_SELECTOR = '[data-theme-toggle]';
  var root = document.documentElement;

  function getSavedMode() {
    try {
      var stored = localStorage.getItem(STORAGE_KEY);

      if (!stored) {
        return null;
      }

      var data = JSON.parse(stored);

      // Remove expired preference
      if (!data.expires || Date.now() > data.expires) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }

      if (data.value === 'light' || data.value === 'dark') {
        return data.value;
      }
    } catch (error) {
      console.warn('Unable to read theme preference:', error);

      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (e) {}
    }

    return null;
  }

  function getSystemMode() {
    if (
      window.matchMedia &&
      window.matchMedia('(prefers-color-scheme: dark)').matches
    ) {
      return 'dark';
    }

    return 'light';
  }

  function getCurrentMode() {
    var currentMode = root.getAttribute('data-color-mode');

    if (currentMode === 'light' || currentMode === 'dark') {
      return currentMode;
    }

    return getSavedMode() || getSystemMode();
  }

  function updateButton(button, mode) {
    var isDark = mode === 'dark';
    var label = isDark
      ? 'Switch to light mode'
      : 'Switch to dark mode';

    button.setAttribute('aria-pressed', isDark ? 'true' : 'false');
    button.setAttribute('aria-label', label);
    button.setAttribute('title', label);
  }

  function updateAllButtons(mode) {
    var buttons = document.querySelectorAll(BUTTON_SELECTOR);

    buttons.forEach(function (button) {
      updateButton(button, mode);
    });
  }

  function saveMode(mode) {
    try {
      var data = {
        value: mode,
        expires: Date.now() + EXPIRY_MS
      };

      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {
      console.warn('Unable to save theme preference:', error);
    }
  }

  function applyMode(mode, shouldSave) {
    var normalizedMode = mode === 'dark' ? 'dark' : 'light';

    root.setAttribute('data-color-mode', normalizedMode);
    root.style.colorScheme = normalizedMode;

    if (document.body) {
      document.body.setAttribute('data-color-mode', normalizedMode);
    }

    if (shouldSave) {
      saveMode(normalizedMode);
    }

    updateAllButtons(normalizedMode);

    document.dispatchEvent(
      new CustomEvent('store:color-mode-change', {
        detail: {
          mode: normalizedMode
        }
      })
    );
  }

  function handleToggleClick(event) {
    event.preventDefault();
    event.stopPropagation();

    var currentMode = getCurrentMode();
    var nextMode = currentMode === 'dark' ? 'light' : 'dark';

    applyMode(nextMode, true);
  }

  function bindButton(button) {
    if (!button || button.getAttribute('data-theme-toggle-bound') === 'true') {
      return;
    }

    button.setAttribute('data-theme-toggle-bound', 'true');
    button.addEventListener('click', handleToggleClick);

    updateButton(button, getCurrentMode());
  }

  function bindAllButtons() {
    var buttons = document.querySelectorAll(BUTTON_SELECTOR);

    buttons.forEach(function (button) {
      bindButton(button);
    });
  }

  function initializeThemeToggle() {
    var initialMode = getSavedMode() || getSystemMode();

    applyMode(initialMode, false);
    bindAllButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeThemeToggle
    );
  } else {
    initializeThemeToggle();
  }

  document.addEventListener('shopify:section:load', function () {
    bindAllButtons();
    updateAllButtons(getCurrentMode());
  });

  document.addEventListener('shopify:section:select', function () {
    bindAllButtons();
    updateAllButtons(getCurrentMode());
  });

  var observer = new MutationObserver(function () {
    bindAllButtons();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();